var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVector3 = function SvgVector3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 300,
    fill: "none",
    viewBox: "-50 -150 1314 916"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#vector-3_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#vector-3_svg__b)",
    d: "m983.734 569.095 90.746-91.745c51.82-52.38 51.82-136.702 0-189.081l-47.84-48.374A134.46 134.46 0 0 0 931.059 200H387.384c-57.433 0-103.991 46.558-103.991 103.991a104 104 0 0 1-30.059 73.131l-97.476 98.544A134.44 134.44 0 0 0 117 570.207v11.358C117 655.811 177.189 716 251.435 716h105.349a134.44 134.44 0 0 0 95.577-39.895l26.925-27.22a134.43 134.43 0 0 1 95.577-39.895h313.294a134.44 134.44 0 0 0 95.577-39.895"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "vector-3_svg__b",
    x1: 564.506,
    x2: 564.506,
    y1: 748.88,
    y2: 200,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21EAB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BCE9F"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "vector-3_svg__a",
    width: 1396.34,
    height: 916,
    x: -83,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3275_24491"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_3275_24491",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect2_foregroundBlur_3275_24491",
    stdDeviation: 100
  })))));
};
export default SvgVector3;